const AddButton = ({
  onClick,
  title,
  fontSize = "13px",
  containerHeight = "400px",
  withCardWrapper = true,
}) => {
  const content = (
    <div
      style={{
        height: containerHeight,
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      }}
    >
      <div
        className="d-flex justify-content-center"
        style={{
          width: "147px",
          height: "140px",
          border: "2px dashed #408FA0",
          borderRadius: "20px",
          padding: "15px",
        }}
      >
        <div
          style={{
            width: "125px",
            height: "108px",
            backgroundColor: "#F5F5F5",
            borderRadius: "20px",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "6px 8px",
            boxSizing: "border-box",
            overflow: "hidden",
          }}
          onClick={onClick}
        >
          <i
            className="fa fa-plus d-flex justify-content-center"
            style={{ fontSize: "28px", color: "#408FA0", flexShrink: 0 }}
          ></i>
          <span
            className="d-flex justify-content-center align-item-center"
            style={{
              font: "OpenSans",
              fontSize: fontSize,
              color: "#408FA0",
              textAlign: "center",
              lineHeight: "1.15",
              width: "100%",
              marginTop: "4px",
              whiteSpace: "normal",
              wordBreak: "break-word",
              overflow: "hidden",
            }}
          >
            {title}
          </span>
        </div>
      </div>
    </div>
  );

  if (!withCardWrapper) {
    return content;
  }

  return (
    <div className="card border-0">
      <div className="tab-content p-3">
        <div className="tab-pane fade show active" id="allTab"></div>
        {content}
      </div>
    </div>
  );
};

export default AddButton;